import { React, useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Flex, Button, Search, MTable, XCircle, MLink, Text } from "@cisco/spaces-dash-lib-styleguide";
import { NodeContext } from "../../contexts/nodeContext";
import * as BusinessHierarchyService from "../../service/business-hierarchy-service";
import CameraEmpty from "../../assets/images/location-accesspoints/camera_empty_lh2.svg";
import { I18nContext } from "../../contexts/i18nContext";
import CustomSearch from "../custom-search/custom-search";
import useLoader from "../../hooks/useLoader";
import "../../common/common_style.scss";
import "../../common/global_style.scss";
import "./location-cameras.scss";

function LocationCameras(props) {
  const i18n = useContext(I18nContext);
  const navigate = useNavigate();
  const { node, cameraCount } = useContext(NodeContext);
  const [locationNode] = useState({ ...node });
  const [searchText, setSearchText] = useState("");
  const rsearchText = useRef("");
  const [cameraListState, setCameraListState] = useState([]);
  const [cameraListFilteredState, setCameraListFilteredState] = useState([]);
  const [cameraListPagedState, setCameraListPagedState] = useState([]);
  const [totalNoOfItems, setTotalNoOfItems] = useState(cameraCount);
  const rtotalNoOfItems = useRef(cameraCount);
  const { setLoading } = useLoader();
  const [showTable, setShowTable] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const rowsPerPageRef = useRef(10);
  const [paginationKey, setPaginationKey] = useState(0);
  let cameraList = [];
  let cameraListFILTERED = [];
  const setText = i18n.t("location-cameras.set-text");
  const notSetText = i18n.t("location-cameras.not-slash-set-text");
  let cameraListPaged = [];
  const appUserSearchSkeleton = {
    name: "string",
    macAddress: "string"
  };

  const processCameraListResponse = (response) => {
    if (response.status) {
      cameraList = response.data ? response.data : [];
      setTotalNoOfItems(cameraCount);
      rtotalNoOfItems.current = cameraCount;
      cameraList = cameraList.map((obj) => ({
        ...obj,
        tripWireText: obj.tripwires && obj.tripwires.length > 0 ? setText : notSetText
      }));
      setCameraListState(cameraList);
    } else {
      cameraList = [];
      setCameraListState([]);
      cameraListFILTERED = [];
      setCameraListFilteredState([]);
      cameraListFILTERED = [];
    }
    cameraListFILTERED = cameraList;
    setCameraListFilteredState(cameraListFILTERED);
    setLoading(false);
  };

  const processCameraListResponseFromSearch = (response) => {
    if (response.status) {
      cameraList = response.data ? response.data : [];
      setTotalNoOfItems(cameraList.length);
      rtotalNoOfItems.current = cameraList.length;
      cameraList = cameraList.map((obj) => ({
        ...obj,
        tripWireText: obj.tripwires && obj.tripwires.length > 0 ? setText : notSetText
      }));
      setCameraListState(cameraList);
    } else {
      cameraList = [];
      setCameraListState([]);
      cameraListFILTERED = [];
      setCameraListFilteredState([]);
      cameraListFILTERED = [];
    }
    cameraListFILTERED = cameraList;
    setCameraListFilteredState(cameraListFILTERED);
    setLoading(false);
  };

  const refreshPaginator = () => {
    setPageNumber(0);
    setRowsPerPage(rowsPerPageRef.current);
    cameraListPaged = cameraListFILTERED;
    setCameraListPagedState(cameraListPaged);
  };

  const getStart = (currentPage) => {
    return currentPage * rowsPerPageRef.current;
  };

  const getEnd = (currentPage) => {
    return currentPage * rowsPerPageRef.current + rowsPerPageRef.current;
  };

  const getCameraList = (currentPageNo = 0) => {
    setShowTable(true);
    setLoading(true);
    BusinessHierarchyService.getLocationCameraList(locationNode.id, getStart(currentPageNo), getEnd(currentPageNo))
      .then((response) => {
        setLoading(false);
        const list = response.data ? response.data : [];
        if (list.length != cameraCount) {
          setTotalNoOfItems(list.length);
        }
        processCameraListResponse(response);
        if (currentPageNo == 1) {
          refreshPaginator();
        } else {
          cameraListPaged = cameraListFILTERED;
          setCameraListPagedState(cameraListPaged);
        }
      })
      .catch((error) => {
        setLoading(false);
        cameraList = [];
        setCameraListState([]);
        cameraListFILTERED = [];
        setCameraListFilteredState([]);
        cameraListFILTERED = [];
        refreshPaginator();
        console.log(`Location Cameras: Error on getCameraList${error}`);
      });
  };

  const onPageChange = (event) => {
    cameraListFILTERED = cameraListFilteredState;
    if (rsearchText.current && rsearchText.current != "") {
      cameraListPaged = cameraListFILTERED;
      setCameraListPagedState(cameraListPaged);
    } else {
      getCameraList(event);
    }
  };

  const filterValue = (event) => {
    setSearchText(event.target.value);
    rsearchText.current = event.target.value;
    if (rsearchText.current == "") {
      rtotalNoOfItems.current = cameraCount;
      setTotalNoOfItems(cameraCount);
    }
  };

  const clearSearch = () => {
    setSearchText("");
    rsearchText.current = "";
    setPageNumber(0);
    setRowsPerPage(10);
    rowsPerPageRef.current = 10;
    rtotalNoOfItems.current = cameraCount;
    setTotalNoOfItems(cameraCount);
    getCameraList(0);
  };

  const navigateToCamera = () => {
    navigate("/setup/camera");
  };

  const getCameraSearchList = (paramType, currentPageNo = 0) => {
    setLoading(true);
    setShowTable(true);
    BusinessHierarchyService.searchCameras(locationNode.id, rsearchText.current, paramType)
      .then((response) => {
        setLoading(false);
        processCameraListResponseFromSearch(response);
        if (currentPageNo == 0) {
          refreshPaginator();
        } else {
          cameraListPaged = cameraListFILTERED;
          setCameraListPagedState(cameraListPaged);
        }
      })
      .catch((error) => {
        setLoading(false);
        cameraList = [];
        setCameraListState([]);
        cameraListFILTERED = [];
        setCameraListFilteredState([]);
        cameraListFILTERED = [];
        refreshPaginator();
        console.log(`Location Cameras: Error on getCameraSearchList${error}`);
      });
  };

  const onAdminSearchFilter = () => {
    if (rsearchText.current) {
      const regex = /^[a-fA-F0-9:]{17}|[a-fA-F0-9]{12}$/;
      let paramType = "";
      if (regex.test(rsearchText.current)) {
        paramType = "macAddress";
      } else {
        paramType = "name";
      }
      getCameraSearchList(paramType);
    } else {
      getCameraList();
    }
  };

  const processCameraListResponseForInitial = (response) => {
    if (response.status) {
      cameraList = response.data ? response.data : [];
      if (cameraCount <= rowsPerPage && cameraCount != cameraList.length) {
        setTotalNoOfItems(cameraList.length);
        rtotalNoOfItems.current = cameraList.length;
      } else {
        setTotalNoOfItems(cameraCount);
      }
      rtotalNoOfItems.current = cameraList.length;
      cameraList = cameraList.map((obj) => ({
        ...obj,
        tripWireText: obj.tripwires && obj.tripwires.length > 0 ? setText : notSetText
      }));
      setCameraListState(cameraList);
    } else {
      cameraList = [];
      setCameraListState([]);
      cameraListFILTERED = [];
      setCameraListFilteredState([]);
      cameraListFILTERED = [];
    }
    cameraListFILTERED = cameraList;
    setCameraListFilteredState(cameraListFILTERED);
    setLoading(false);
  };

  const initCameraList = (currentPageNo = 0) => {
    setLoading(true);
    BusinessHierarchyService.getLocationCameraList(locationNode.id, getStart(currentPageNo), getEnd(currentPageNo))
      .then((response) => {
        setLoading(false);
        if (response && response.data && response.data.length > 0) {
          setShowTable(true);
        }
        processCameraListResponseForInitial(response);
        if (currentPageNo == 0) {
          refreshPaginator();
        } else {
          cameraListPaged = cameraListFILTERED;
          setCameraListPagedState(cameraListPaged);
        }
      })
      .catch((error) => {
        setLoading(false);
        cameraList = [];
        setCameraListState([]);
        cameraListFILTERED = [];
        setCameraListFilteredState([]);
        cameraListFILTERED = [];
        refreshPaginator();
        console.log(`Location Cameras: Error on getCameraList${error}`);
      });
  };

  useEffect(() => {
    console.log("LocationCameras Mount");
    if (cameraCount && cameraCount > 0) {
      initCameraList();
    }
    console.log(`${props}`);
    return () => {
      console.log("LocationCameras Destroy");
    };
  }, []);

  useEffect(() => {
    setPaginationKey(paginationKey + 1);
  }, [cameraListPagedState]);

  return (
    <div className="ap-wrapper boxShadowBlur" id="cameras-wrapper">
      <Flex direction="vertical" gap={16}>
        <Flex align="center" justify="space-between" gap={8} />
        {showTable && cameraListPagedState && cameraListPagedState.length >= 0 && (
          <Flex align="center" justify="space-between">
            <Flex justify="space-between">
              <Flex align="center" gap={16}>
                <Flex gap={8}>
                  <Search
                    label=""
                    placeholder={i18n.t("proximity-rule.search-text")}
                    onChange={filterValue}
                    value={searchText}
                    options={[]}
                    suffix={searchText.length > 0 && <XCircle title="clear search" size={18} onClick={clearSearch} />}
                  />
                  <CustomSearch
                    searchSkeleton={appUserSearchSkeleton}
                    customSearchText={searchText}
                    shouldUseGlobalSearch={false}
                    rawData={cameraListState}
                    onAdminSearchFilter={onAdminSearchFilter}
                  />
                </Flex>
              </Flex>
            </Flex>
            <Flex justify="space-between">
              <Flex align="center">
                {cameraListPagedState && cameraListPagedState.length > 0 && (
                  <MLink onClick={navigateToCamera} size="md">
                    {i18n.t("location-cameras.on-board-camera-text")}
                  </MLink>
                )}
              </Flex>
            </Flex>
          </Flex>
        )}
        {showTable && cameraListPagedState && cameraListPagedState.length >= 0 && (
          <div className="userTableContainer">
            <MTable.Pagination
              currentPage={pageNumber + 1}
              paginationKey={paginationKey}
              key={cameraListPagedState.length}
              defaultRecordsOption={rowsPerPageRef.current}
              kind={
                rsearchText.current && rsearchText.current != ""
                  ? "client"
                  : {
                      server: {
                        rowCount: totalNoOfItems,
                        onPageChange: (currentPage) => {
                          setPageNumber(currentPage);
                          onPageChange(currentPage);
                        },
                        onRowsPerPageChange: (change) => {
                          rowsPerPageRef.current = change;
                          setRowsPerPage(change);
                          getCameraList(0);
                        }
                      }
                    }
              }
              showNavigation="all"
              showOptions
              showTotal
            >
              <MTable
                columns={[
                  {
                    accessorKey: "name",
                    header: i18n.t("location-cameras.camera-name-text"),
                    meta: {
                      align: "left"
                    },
                    enableSorting: true
                  },
                  {
                    accessorKey: "serialId",
                    header: i18n.t("location-cameras.serial-number-text"),
                    meta: {
                      align: "left"
                    },
                    enableSorting: true
                  },
                  {
                    accessorKey: "macAddress",
                    header: i18n.t("business-location-details.mac-address-text"),
                    meta: {
                      align: "left"
                    },
                    enableSorting: true
                  },
                  {
                    accessorKey: "tripWireText",
                    header: i18n.t("location-cameras.trip-wire-status-text"),
                    meta: {
                      align: "left"
                    },
                    enableSorting: true
                  }
                ]}
                data={cameraListPagedState}
              />
            </MTable.Pagination>
          </div>
        )}
        {!showTable && cameraListPagedState.length == 0 && (
          <div className="team-empty-business">
            <div className="divTable empty_wrapper" id="network-cameras-texts">
              <div className="divTableRow">
                <div className="divTableCell width50_middle">
                  <div className="title">
                    <Text size="p1" weight="bold">
                      {i18n.t("location-cameras.no-meraki-camera-text")}
                    </Text>
                  </div>
                  <div className="desc">
                    <Text size="p2" weight="regular" color="light">
                      {i18n.t("location-cameras.configure-camera-settings-text")}
                    </Text>
                  </div>
                  <Button type="primary" onClick={navigateToCamera}>
                    {i18n.t("location-cameras.setup-section-to-configure-camera-text")}
                  </Button>
                </div>
                <div className="divTableCell width50_middle">
                  <div>
                    <img alt="camera missing" className="team-empty-img" src={CameraEmpty} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Flex>
    </div>
  );
}

export default LocationCameras;
